export default "__VITE_ASSET__B661121a__"